export default "__VITE_ASSET__QY74BV$GEpgDuiothlyAwQ__"